import React, { useState } from "react";
import Line from "../../../assets/line2.svg";

export default function CustomPlans() {
  const [searchCredits, setSearchCredits] = useState(1000);

  const calculatePrice = (credits) => (credits * 0.01).toFixed(2);

  const totalPrice = calculatePrice(searchCredits);

  const handlenav = () => {
    window.location.href = process.env.REACT_APP_BASE_URL;
  };

  return (
    <div className="bg-custom-gradient1">
      <div className="pt-12 px-5 flex flex-col items-center">
        <div className="text-center w-full md:w-[70%] mb-2 mt-2 lg:mt-7">
          <h2 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold">
            <span className="relative inline-block">
              Custom Plans{" "}
              <img
                src={Line}
                alt="Underline decoration"
                className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
              />
            </span>{" "}
            for Unique Needs
          </h2>
          <p className="text-xl md:text-2xl my-4 mt-8">
            Easy and reliable email verification.{" "}
          </p>
          <p className="text-xl md:text-2xl">
            Get accurate results fast, with our advanced multi-step verification
            process.
          </p>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-20 p:10 lg:px-20 lg:pt-14 lg:pb-24">
        <div className="order-1 bg-[#F7F9FA] flex-1 p-6 rounded-lg space-y-6 flex flex-col text-left">
          <h2 className="text-xl font-semibold text-gray-800">
            How many credits do you want to purchase?
          </h2>

          <div className="space-y-2">
            <h3 className="text-md font-semibold text-gray-700">
              Search credits
            </h3>
            <input
              type="range"
              min="1000"
              max="1000000"
              step="1000"
              value={searchCredits}
              onChange={(e) => setSearchCredits(parseInt(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            />
            <div className="flex justify-between text-gray-500 text-sm">
              <span>1,000</span>
              <span>10,000</span>
              <span>100,000</span>
              <span>1M</span>
            </div>
            <div className="text-right text-gray-700 font-semibold">
              {searchCredits.toLocaleString()} Credits
            </div>
          </div>

          <p className="text-sm text-gray-500">
            Search credits are used to find emails through the{" "}
            <span className="text-blue-500 underline">Domain Search</span> or{" "}
            <span className="text-blue-500 underline">Email Finder</span>, and
            Verification credits are used to verify emails with the{" "}
            <span className="text-blue-500 underline">Email Verifier</span>.
            More details can be found{" "}
            <span className="text-blue-500 underline">here</span>.
          </p>
          <p className="text-sm text-gray-500">
            Each repeated search or verification is counted once per calendar
            month.
          </p>
        </div>

        <div className="order-2 flex-1 bg-[#F7F9FA] p-6 rounded-lg space-y-6 text-center flex flex-col justify-center items-center">
          <h3 className="text-lg text-gray-800">Your Bulk credits purchase</h3>
          <p className="text-3xl lg:text-4xl lg:font-semibold font-bold text-gray-800">
            ${totalPrice} USD
          </p>

          <div className="space-y-4 w-full !mt-16">
            <hr className="border-gray-300" />

            <div className="flex justify-between text-gray-700">
              <span className="text-left">
                {searchCredits.toLocaleString()} Search credits
              </span>
              <span>${totalPrice} USD</span>
            </div>
            <hr className="border-gray-300" />

            <p className="text-sm text-left text-gray-500">
              Credits can be used up to 12 months from purchase.
            </p>
          </div>

          <button onClick={handlenav} className="w-full py-3 text-white bg-background hover:bg-hover rounded-lg transition">
            Get started
          </button>
        </div>
      </div>
    </div>
  );
}
